<template>
  <div class="grow flex flex-col gap-3xs">
    <Skeleton class="h-5 w-3/4 rounded" />
    <Skeleton class="h-3 w-1/2 rounded" />
  </div>
  <div class="flex items-center gap-2xs">
    <Skeleton class="h-6 w-6 rounded" />
    <Skeleton class="h-6 w-6 rounded-full" />
  </div>
</template>
